import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate(res.data.role === "admin" ? "/admin" : "/account", { state: { user: res.data } });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center">
      <div className="text-center">
        <div className="h-12 w-12 rounded-full border-2 border-gold border-t-transparent animate-spin mx-auto" />
        <p className="font-display text-2xl text-gold mt-6 smallcaps tracking-widest">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
